<template>
  <div>
    <vx-card :title="`${$t('work_time_set')} ${company.worktime_start} ${$t('extension_status_to')} ${company.worktime_end}`" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" toggleButtonSize="small" @keyup.enter="loadExtensionStatusDataAnalysis(1, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-edit" size="small" @click="editCompanyWorktimePopup">{{ $t('extension_status_working_hours_settings') }}</vs-button>
      </template>
      <div class="vx-row">
        <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
          <date-picker v-model="searchParams.date" :model="searchParams.date" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadExtensionStatusDataAnalysis(1, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="extensionStatusDataAnalysisDataContainer" :title="$t('extension_status_data_analysis')" class="mb-8 vs-con-loading__container">
      <shared-extension-status-data-analysis-list
        :records="records"
        @extensionViewDetails="viewExtension"
      ></shared-extension-status-data-analysis-list>
    </vx-card>

  </div>
</template>

<script>
import SharedExtensionStatusDataAnalysisList from '@/views/Shared/ExtensionStatusDataAnalysis/List'
import ExtensionStatusDataAnalysis from '@/models/ExtensionStatusDataAnalysis'
import DatePicker from '@/components/form-inputs/DatePicker'
import Utils from '@/helpers/utils'
import SharedUserList from '@/views/Shared/User/List.vue'

export default {
  name: 'User.CallStatistics.ExtensionStatusDataAnalysis',
  components: {
    SharedUserList,
    DatePicker,
    SharedExtensionStatusDataAnalysisList
  },
  data () {
    return {
      records: {},
      company: {
        worktime_start: '',
        worktime_end: ''
      },
      searchParams: {
        date: typeof this.$route.query.date !== 'undefined' ? this.$route.query.date : ''
      }
    }
  },
  mounted () {
    this.loadExtensionStatusDataAnalysis()
    this.$windowOpenerHelper.listenToPopUpMessage('reload_worktime_display', this.loadExtensionStatusDataAnalysis)
  },
  methods: {
    editCompanyWorktimePopup () {
      Utils.openPopUp('window', 'edit-company-worktime', {})
    },
    async loadExtensionStatusDataAnalysis () {
      this.$vs.loading({container: '#extensionStatusDataAnalysisDataContainer'})

      this.$router.replace({ query: { ...this.searchParams } })
      const response = await ExtensionStatusDataAnalysis.findAll({ ...this.searchParams })
      this.records = response.data.records
      this.company = response.data.company

      this.$vs.loading.close('#extensionStatusDataAnalysisDataContainer > .con-vs-loading')
    },
    viewExtension (key, data) {
      Utils.openPopUp('window', 'view-extension-status-data-analysis', {
        date: this.searchParams.date,
        ext: data.extension_number
      })
    }
  }
}
</script>

<style lang="scss">

</style>

